define(["./click"], function (_click) {
  "use strict";
});